import { type ReactNode, useState } from "react";

import { RootStore } from "./root-store";
import { StoreContext } from "./store-context";

export function StoreProvider({ children }: { children: ReactNode }): React.JSX.Element {
  const [rootStore] = useState(() => new RootStore());

  return <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>;
}
